export const TUPLE_SELECTOR_TEXT = `Forge expression yielding tuples (arity ≥ 2); constraint applies from first to last element.`;
export const UNARY_SELECTOR_TEXT = `Forge expression yielding singletons.`;

export const CYCLIC_DESCRIPTION = "Arrange elements along the perimeter of a circle."
export const ORIENTATION_DESCRIPTION = "Specify the relative positioning of elements."
export const ALIGN_DESCRIPTION = "Ensure elements are aligned horizontally or vertically."
export const GROUPING_SELECTOR_DESCRIPTION = "Group elements based on a selector."
export const GROUPING_FIELD_DESCRIPTION = "Group elements based on a field."
export const SIZE_DESCRIPTION = "Set the width and height of elements matching the selector."
export const HIDEATOM_DESCRIPTION = "Hide elements matching the selector from the visualization."
export const TAG_DESCRIPTION = "Add computed attributes to nodes based on n-ary selector evaluation."
export const DEFAULT_NODE_WIDTH = 100;
export const DEFAULT_NODE_HEIGHT = 60;
